import { api } from '@/utils/api'
import alert from '../helpers/alert'

const moduleType = 'RF'

const state = () => {
  return {
    btnSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnCancel: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDraft: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnItemSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnReject: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDelete: {
      disabled: false,
      loading: false,
      hide: true
    },
    tableTab: {
      label: null,
      value: null,
      url: null,
      currentUrl: null,
      page: 1
    },
    search: {
      field: null,
      type: 'like',
      value: null,
      companySelected: [],
      statusSelected: []
    },
    approveOption: [],
    // shippingRecipientOption: [],
    // shippingConditionPaymentOption: [],
    isClaim: false,
    isApprove: false,
    countMyDoc: 0,
    documentPath: [],
    documentPathText: [],
    docStatusOption: [],
    files: [],
    // memo: [],
    orderType: [],
    orderTypeDefault: null,
    ofList: [],
    grInstalmentType: [],
    grInstalmentTypeDefault: null,
    grInstalmentNo: null,
    vendorInOFList: []
  }
}

const getters = {
  getFileAttach(state) {
    return state.files.map(item => {
      return {
        id: item.id,
        path_file: item.path_file,
        path_thumbnail: item.path_thumbnail,
        url_file: item.url_file,
        url_thumbnail: item.url_thumbnail
      }
    })
  },
  getPaymentByOne(state) {
    return selected => {
      return state.shippingConditionPaymentOption.find(
        item => item.value == selected
      )
    }
  },
  getInstalmentTypeText(state) {
    return type => {
      // return type
      if (state.grInstalmentType.length > 0) {
        const t = state.grInstalmentType.find(item => item.value == type)
        return t ? t.label : ''
      } else {
        return ''
      }
    }
  }
  // getInstalmentTypeDefault(state) {
  //   if (state.grInstalmentType.length > 0) {
  //     return state.grInstalmentType[0].value
  //   } else {
  //     return 'kkkk'
  //   }
  // }
  // getInstalmentTypeOption(state) {
  //   return state.grInstalmentType.map(item => {
  //     return {
  //       label: item
  //     }
  //   })
  // }
}

const mutations = {
  initBtn(state) {
    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnItemSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnReject = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDelete = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.isClaim = false
    state.isApprove = false
    state.countMyDoc = 0
    state.files = []
    state.memo = []
    state.prList = []
    // state.docStatusOption = []
    state.documentPath = []
    state.documentPathText = []
  },
  setBtnActive(state, data) {
    state[data.type].loading = !state[data.type].loading
    state[data.type].disabled = !state[data.type].disabled
  },
  setBtnActiveFix(state, data) {
    state[data.type].loading = data.status
    state[data.type].disabled = data.status
  },
  setBtn(state, data) {
    state[data.type][data.value] = !state[data.type][data.value]
  },
  resetFile(state) {
    state.files = []
  },
  setFile(state, data) {
    state.files.push(data)
  },
  removeFile(state, id) {
    const newFile = state.files.filter(item => {
      return item.id !== id
    })
    state.files = newFile
  },
  setBtnDisplay(state, data) {
    state[data.key].hide = !data.status
  },
  setDocStatusOption(state, data) {
    state.docStatusOption = data
  },
  setCountMyDoc(state, count) {
    state.countMyDoc = count
  },
  setTableTab(state, tab) {
    state.tableTab.label = tab.label
    state.tableTab.value = tab.value
    state.tableTab.url = tab.url
    state.tableTab.currentUrl = tab.url
  },
  setCompanyAndStatus(state, data) {
    state.search.companySelected = data.companySelected
    state.search.statusSelected = data.statusSelected
    state.search.field = data.field
    state.search.value = data.value
  },
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  },
  clearTableTab(state, data) {
    state.search.companySelected = []
    state.search.statusSelected = []
    state.search.field = data.field
    state.search.value = null

    state.tableTab.currentUrl = state.tableTab.url
    state.tableTab.page = 1
  },
  clearSelectedCompanyAndStatus(state) {
    state.search.companySelected = []
    state.search.statusSelected = []
  },
  setDocumentPath(state, data) {
    state.documentPath = data
  },
  setDocumentPathText(state, data) {
    state.documentPathText = data
    // console.log('data:', data)
  },
  setApproveOption(state, data) {
    state.approveOption = data
  },
  setIsClaim(state, data) {
    state.isClaim = data
  },
  setIsApprove(state, data) {
    state.isApprove = data
  },
  // setMemo(state, data) {
  //   state.memo = data
  // },
  setOFList(state, data) {
    state.ofList = data
  },
  setGrInstalmentType(state, data) {
    state.grInstalmentType = data
    if (data.length > 0) {
      state.grInstalmentTypeDefault = data[0].value
    }
  },
  setGrInstalmentTypeDefault(state, data) {
    state.grInstalmentTypeDefault = data
  },
  setGrInstalmentNo(state, data) {
    state.grInstalmentNo = data
  },
  setOrderType(state, data) {
    state.orderType = data
  },
  setOrderTypeDefault(state, data) {
    state.orderTypeDefault = data
  },
  setVendorInOFList(state, data) {
    state.vendorInOFList = data
  }
}

const actions = {
  async loadDocumentPath({ commit }, payload) {
    let urlApi = null
    console.log('load special: ', payload.specialPath)
    if (payload.specialPath === null || payload.specialPath === undefined) {
      urlApi = `/hr/employee/documentPath?doc_type=${moduleType}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
    } else {
      urlApi = `/hr/employee/documentPath?doc_type=${moduleType}&special_path=${payload.specialPath}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
    }

    await api.get(urlApi).then(res => {
      if (res.code == 200) {
        commit('setDocumentPath', res.data.documentPath)
        commit('setDocumentPathText', res.data.documentPathText)
      }
    })
  },
  async loadDocStatusOption({ commit, state, rootState }) {
    if (state.docStatusOption.length == 0) {
      await api
        .get(
          `/preorder/rf/getOptionDocMenu?showTabMonitor=${rootState.auth.info.showTabMonitor}&roleCode=${rootState.auth.info.roleCode}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocStatusOption', res.data)
            commit('setTableTab', res.data[0])
          }
        })
    }
  },
  async loadCountMyDoc({ commit }, employeeId) {
    await api.get(`/preorder/rf/countDocWait/${employeeId}`).then(async res => {
      if (res.code == 200) {
        commit('setCountMyDoc', res.data.doc_wait)
        commit(
          'global/setDocWaitType',
          { type: 'gr', value: res.data.doc_wait },
          { root: true }
        )
      }
    })
  },
  // async loadMemo({ commit }, data) {
  //   await api
  //     .get(
  //       `/memo/memo/getMyDocForUse?back_month=6${
  //         data.ememoId !== null ? '&ememoId=' + data.ememoId : ''
  //       }`
  //     )
  //     .then(res => {
  //       if (res.code == 200) {
  //         commit('setMemo', res.data.data)
  //       }
  //     })
  // },
  async approveClaim({ commit }, data) {
    return await api
      .post('/preorder/rf/claim', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsClaim', false)
          alert.success()
          return res.data.employee_id
        } else {
          alert.error(res.message)
          return false
        }
        // return { code:// res.code, message: res.message }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  async loadApproveOption({ commit, state }, data) {
    await api
      .get(
        `/preorder/rf/getOptionApproveResult?employeeId=${data.employeeID}&docId=${data.docID}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setApproveOption', res.data)
        }
      })
  },
  async approveRF({ commit }, data) {
    return await api
      .post('/preorder/rf/approve', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsApprove', true)
          alert.success()
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  async loadOFList({ commit }, data) {
    let url = `/preorder/rf/getOfForRf?reqId=${data.employeeId}&company=${data.company}`
    if (data.poId !== undefined) {
      url += `&poId=${data.poId}`
    }
    const keepVendor = []
    return await api
      .get(url)
      .then(res => {
        if (res.code == 200) {
          const tmp = res.data.map(item => {
            item.selected = false
            item.items.map(sub => {
              sub.selected = false
              sub.is_edit = false
              sub.bargain_discount = ''
              sub.qty_po_diff = 0
              sub.wh_tax = 0
              sub.wh_tax_rate = 3
              sub.gr_item_id = null
              sub.use_price_type = 'of'
              sub.doc_no_full = item.doc_no_full

              if (!keepVendor.find(r => r.value == sub.vendor_code)) {
                keepVendor.push({
                  value: sub.vendor_code,
                  label: sub.vendor_name
                })
              }

              return sub
            })
            return item
          })

          commit('setOFList', tmp)
          commit('setVendorInOFList', keepVendor)
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        console.log('error service rf: ', e)
        return false
      })
  },
  async loadGrOptionInstalmentType({ commit }) {
    const url = '/preorder/rf/getOptionInstalmentType'
    return await api
      .get(url)
      .then(res => {
        if (res.code == 200) {
          commit('setGrInstalmentType', res.data)
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        console.log('error service pr: ', e)
        return false
      })
  },
  async loadGrOptionInstalmentNo({ commit }, data) {
    return await api
      .get(
        `/preorder/rf/getLatestInstalmentNo?poId=${data.poId}${
          data.grId ? `&grId=${data.grId}` : ''
        }`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setGrInstalmentNo', res.data)
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        console.log('error service pr: ', e)
        return false
      })
  },
  // async loadShippingRecipientList({ commit, state }) {
  //   if (state.shippingRecipientOption.length == 0) {
  //     await api
  //       .get('/procurement/po/getShippingRecipientList')
  //       .then(res => {
  //         if (res.code == 200) {
  //           commit('setShippingRecipientList', res.data)
  //         } else {
  //           alert.error(res.message)
  //         }
  //       })
  //       .catch(e => {
  //         console.log('error service pr: ', e)
  //       })
  //   }
  // },
  // async loadShippingConditionPaymentList({ commit, state }) {
  //   if (state.shippingRecipientOption.length == 0) {
  //     await api
  //       .get('/procurement/po/shippingConditionPaymentList')
  //       .then(res => {
  //         if (res.code == 200) {
  //           commit('setShippingConditionPaymentList', res.data)
  //         } else {
  //           alert.error(res.message)
  //         }
  //       })
  //       .catch(e => {
  //         console.log('error service pr: ', e)
  //       })
  //   }
  // },
  async loadOrderType({ commit }, data) {
    return await api
      .get(
        `/procurement/userProfile/getOrderTypeOfUser?comp_no=${data.compNo}&employee_id=${data.employeeId}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setOrderType', res.data)
          commit('setOrderTypeDefault', res.default)
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
  },
  setTableTab({ commit }, tab) {
    commit('setTableTab', tab)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
